import React, { useState, useEffect, useRef } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import uuid from "react-uuid";
import { Formik } from "formik";
import LanguageForm from "./LanguageForm";
import WarningNotiifcation from "components/WarningNotification";
import { connect } from "react-redux";
import { SetLoading } from "redux/actions/loadingActions";
import { SetUser } from "redux/actions/userActions";
import { updateMany } from "services";
import { get } from "services";
import { SetOperationSuccess } from "redux/actions/operationSuccessActions";
import { SetHasLanguage } from "redux/actions/hasLanguageDataActions";
import Spinner from "react-bootstrap/Spinner";
import { useHistory } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
let yup = require("yup");

const LanguageFormWrapper = ({
  user,
  SetLoading,
  SetOperationSuccess,
  opeationSuccess,
  SetHasLanguage,
  hasLanguageDataReducer,
}) => {
  const [languageForm, setLanguageForm] = useState([]);
  const [loadForm, setLoadForm] = useState(false);
  const [formContent, setFormContent] = useState({});
  const [formikSchema, setFormikSchema] = useState({});
  const [basicSchema, setBasicSchema] = useState({});
  const formRef = useRef();
  const [saveAndContinue, setSaveAndContinue] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [empresaId, setEmpresaId] = useState(96);
  const history = useHistory();

  useEffect(() => {
    (async function mounted() {
      if (user.esEmpleado) {
        const empresaId = await get(
          `Empleado/GetEmpresaIdByEmpleado/${user.persona.id}`
        );
        setEmpresaId(empresaId.data);
      }

      if (
        !user.persona.personaIdiomas ||
        user.persona.personaIdiomas.length == 0
      ) {
        const response = await get(
          `PersonaIdioma/GetByPersonaId/${user.persona.id}`
        );
        user.persona.personaIdiomas = response.data;
      }
      if (
        user.persona.personaIdiomas &&
        user.persona.personaIdiomas.length > 0
      ) {
        user.persona.personaIdiomas = user.persona.personaIdiomas.filter(
          (x) => x
        );
        let schema = {};
        let values = {};
        let idiomas = [];

        user.persona.personaIdiomas.forEach((idioma) => {
          const idiomaId = idioma.id;
          schema = {
            ...schema,
            [`language_${idiomaId}`]: yup
              .number()
              .typeError("El campo es numérico")
              .required("El campo es requerido"),
            [`speak_${idiomaId}`]: yup
              .number()
              .typeError("El campo es numérico")
              .required("El campo es requerido"),
            [`read_${idiomaId}`]: yup
              .number()
              .typeError("El campo es numérico")
              .required("El campo es requerido"),
            [`write_${idiomaId}`]: yup
              .number()
              .typeError("El campo es numérico")
              .required("El campo es requerido"),
          };
          values = {
            ...values,
            [`language_${idiomaId}`]: idioma.idiomaId,
            [`speak_${idiomaId}`]: idioma.idiomaNivelId,
            [`read_${idiomaId}`]: idioma.idiomaNivel1Id,
            [`write_${idiomaId}`]: idioma.idiomaNivel2Id,
          };
          idiomas.push({
            id: idiomaId,
            estado: idioma.estado,
            isNew: false,
          });
        });
        setBasicSchema(() => {
          return schema;
        });
        updateFormik(schema);
        setFormContent(() => {
          return values;
        });
        setLanguageForm(() => {
          return [...idiomas];
        });
      }

      setLoadForm(true);
    })();
  }, []);

  useEffect(() => {
    if (loadForm) {
      if (
        (user.persona.personaIdiomas &&
          user.persona.personaIdiomas.length == 0) ||
        user.persona.personaIdiomas.every((x) => x.estado == 0)
      ) {
        onAddLanguageForm();
      }
    }
  }, [loadForm]);

  const notify = (text) =>
    toast.warn(text, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const onSaveAndContinue = () => {
    formRef.current.validateForm().then((data) => {
      if (Object.keys(data).length === 0 && data.constructor === Object) {
        setSaveAndContinue(true);
        formRef.current.handleSubmit();
      }
    });
  };

  const onContinue = () => {
    history.push({
      pathname: "/knowledgeAndSkillsModule",
      state: {
        updateUserData: true,
      },
    });
  };

  const onSave = () => {
    formRef.current.validateForm().then((data) => {
      if (Object.keys(data).length === 0 && data.constructor === Object) {
        setSaveAndContinue(false);
        formRef.current.handleSubmit();
      }
    });
  };

  const onExit = () => {
    history.push({
      pathname: "/language",
      state: {
        updateUserData: true,
      },
    });
  };

  const updateFormik = (schema) =>
    setFormikSchema(() => {
      return yup.object(schema);
    });

  const onAddLanguageForm = () => {
    const guid = uuid();
    const oldValues = formRef.current.values;
    const newSchema = {
      ...basicSchema,
      [`language_${guid}`]: yup
        .number()
        .typeError("El campo es numérico")
        .required("El campo es requerido"),
      [`speak_${guid}`]: yup
        .number()
        .typeError("El campo es numérico")
        .required("El campo es requerido"),
      [`read_${guid}`]: yup
        .number()
        .typeError("El campo es numérico")
        .required("El campo es requerido"),
      [`write_${guid}`]: yup
        .number()
        .typeError("El campo es numérico")
        .required("El campo es requerido"),
    };
    setBasicSchema(() => {
      return newSchema;
    });
    setFormContent(() => {
      return {
        ...oldValues,
        [`language_${guid}`]: "",
        [`speak_${guid}`]: "",
        [`read_${guid}`]: "",
        [`write_${guid}`]: "",
      };
    });
    setLanguageForm(() => {
      return [
        ...languageForm,
        {
          id: guid,
          estado: 1,
          isNew: true,
        },
      ];
    });
    updateFormik(newSchema);
  };

  const onRemoveLanguageForm = (identifier) => {
    let newSchema = basicSchema;
    const oldValues = formRef.current.values;
    const removedForm = languageForm.find((x) => x.id === identifier);

    const schemaKeys = [
      `language_${identifier}`,
      `speak_${identifier}`,
      `read_${identifier}`,
      `write_${identifier}`,
      `modality_${identifier}`,
    ];

    schemaKeys.forEach((key) => {
      delete newSchema[key];
      delete oldValues[key];
    });

    setBasicSchema(() => {
      return newSchema;
    });
    setFormContent(() => {
      return oldValues;
    });
    updateFormik(newSchema);

    if (removedForm.isNew) {
      setLanguageForm(() => {
        return [...languageForm.filter((x) => x.id !== identifier)];
      });
    } else {
      removedForm.estado = 0;
      setLanguageForm(() => {
        return [...languageForm];
      });
    }
  };

  const onFormSubmitted = async (form) => {
    //debugger;

    let personaIdiomas = [];

    let onCancelOperation = {
      cancelOperation: false,
      languages: [],
    };

    languageForm.forEach((language) => {
      const languageId = Number(
        language.estado == 0
          ? user.persona.personaIdiomas.find((x) => x.id == language.id)
              ?.idiomaId
          : form["language_" + language.id]
      );
      const idiomaNivelId = Number(
        language.estado == 0
          ? user.persona.personaIdiomas.find((x) => x.id == language.id)
              ?.idiomaNivelId
          : form["speak_" + language.id]
      );
      const idiomaNivel1Id = Number(
        language.estado == 0
          ? user.persona.personaIdiomas.find((x) => x.id == language.id)
              ?.idiomaNivel1Id
          : form["read_" + language.id]
      );
      const idiomaNivel2Id = Number(
        language.estado == 0
          ? user.persona.personaIdiomas.find((x) => x.id == language.id)
              ?.idiomaNivel2Id
          : form["write_" + language.id]
      );
      const personaIdioma = {
        id: language.isNew ? null : language.id,
        idiomaId: languageId,
        personaId: user.persona.id,
        estado: language.estado,
        idiomaNivelId,
        idiomaNivel1Id,
        idiomaNivel2Id,
      };

      if (personaIdiomas) {
        if (
          personaIdiomas.some(
            (personaIdioma) => personaIdioma.idiomaId == languageId
          )
        ) {
          if (!onCancelOperation.languages.some((x) => x == languageId)) {
            onCancelOperation.languages.push(languageId);
          }
          onCancelOperation.cancelOperation = true;
        }
      }
      personaIdiomas.push(personaIdioma);
    });

    if (onCancelOperation.cancelOperation) {
      onCancelOperation.languages.forEach(async (languageId) => {
        const language = await get("Idioma?$filter=id eq " + languageId);
        notify(
          "No puede agregar el idioma " +
            language.data[0].nombre +
            " más de una vez"
        );
      });
      return;
    }

    setIsLoading(true);

    const response = await updateMany(
      "PersonaIdioma",
      personaIdiomas /* , reCAPTCHA */
    );
    user.persona = {
      ...user.persona,
      personaIdiomas: [...response.data],
    };
    SetUser(user);
    localStorage.setItem("currentUser-ARS", JSON.stringify(user));
    setIsLoading(false);
    SetOperationSuccess(opeationSuccess + 1);

    if (response && response.data && response.data.some((x) => x.estado == 1)) {
      SetHasLanguage(true);
    } else {
      SetHasLanguage(false);
    }

    const route = saveAndContinue ? "/knowledgeAndSkillsModule" : "/language";
    history.push({
      pathname: route,
      state: {
        updateUserData: true,
      },
    });
  };

  return (
    <>
      <ToastContainer />
      {isLoading && (
        <div className={"display-flex flex-direction-row flex-center"}>
          <Spinner
            animation="grow"
            variant="primary"
            className={"is-absolute center-spinner-vertically"}
            size="lg"
          />
        </div>
      )}
      <Card>
        <Card.Body className={"p-40"}>
          {loadForm && (
            <div>
              <Formik
                innerRef={formRef}
                validationSchema={formikSchema}
                onSubmit={onFormSubmitted}
                initialValues={formContent}
                enableReinitialize={true}
                validateOnChange={false}
                validateOnBlur={false}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  isValid,
                  errors,
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Form.Row>
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="campos_obligatorios"
                        className="mb-25"
                        style={{ fontSize: 18 }}
                      >
                        <div>{/* <b> Campos obligatorios * </b> */}</div>
                      </Form.Group>
                      {languageForm.length > 0 &&
                      languageForm.filter((x) => x.estado == 1).length > 0 ? (
                        languageForm
                          .filter(
                            (x) => x.estado == 1 && `language_${x.id}` in values
                          )
                          .map((element) => {
                            return (
                              <LanguageForm
                                key={element.id}
                                handleChange={handleChange}
                                errors={errors}
                                touched={touched}
                                values={values}
                                element={element}
                                removeLanguageForm={onRemoveLanguageForm}
                                empresaId={empresaId}
                              />
                            );
                          })
                      ) : (
                        <Form.Group as={Col} md="12">
                          <WarningNotiifcation
                            message="No ha agregado formularios a la sección "
                            enphasis="Idiomas"
                          />
                        </Form.Group>
                      )}
                      <Form.Group
                        className={"display-flex flex-end"}
                        as={Col}
                        md="12"
                      >
                        <Button onClick={onAddLanguageForm}> Agregar </Button>
                      </Form.Group>
                    </Form.Row>

                    {languageForm.length > 0 && (
                      <Form.Group
                        className={"display-flex space-between padding-right-0"}
                        as={Col}
                        md="12"
                      >
                        {hasLanguageDataReducer ? (
                          <Button
                            size="medium"
                            variant="light"
                            onClick={onExit}
                          >
                            {" "}
                            <b> Cancelar edición </b>{" "}
                          </Button>
                        ) : (
                          <div> </div>
                        )}
                        <div>
                          <Button
                            size="medium"
                            type="button"
                            onClick={onContinue}
                          >
                            {" "}
                            <b> Continuar </b>{" "}
                          </Button>
                          <Button
                            className={"margin-left-5"}
                            size="medium"
                            type="button"
                            onClick={onSave}
                          >
                            {" "}
                            <b> Guardar </b>{" "}
                          </Button>
                          <Button
                            className={"margin-left-5"}
                            size="medium"
                            type="button"
                            onClick={onSaveAndContinue}
                          >
                            {" "}
                            <b> Guardar y continuar </b>{" "}
                          </Button>
                        </div>
                      </Form.Group>
                    )}
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    opeationSuccess: state.opeationSuccess,
    hasLanguageDataReducer: state.hasLanguageDataReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SetUser: (user) => dispatch(SetUser(user)),
    SetLoading: (value) => dispatch(SetLoading(value)),
    SetOperationSuccess: (value) => dispatch(SetOperationSuccess(value)),
    SetHasLanguage: (value) => dispatch(SetHasLanguage(value)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguageFormWrapper);
